import React from 'react';
import './aboutus.css'; 

function OurFaculty() {
  const facultyData = [

    {
      name: 'Prof. Dr. M Dissanayake MBBS, MD',
      title: (
        <>
          Consultant Eye Surgeon, Department of Anatomy,<br />
          Faculty of Medicine, University of Colombo
        </>
      ),
    },

    {
      name: 'Dr. Amila De Alwis MBBS, MD',
      title: 'Consultant Eye Surgeon, Visiting Lecturer',
    },

    {
      name: 'Dr. Ayasmantha Peiris MBBS, MD',
      title: 'Consultant Eye Surgeon, Visiting Lecturer',
    },

    {
      name: 'Dr. Kusum Ratnayake MBBS, MD',
      title: (
        <>
          Consultant Cornea & External Eye Disease,<br />
          National Eye Hospital Colombo
        </>
      ),
    },

    {
      name: 'Dr. Dhanuka Weerasinghe MBBS, MD',
      title: 'Consultant Eye Surgeon',
    },
    {
      name: 'Dr. Lahiru Kumarage MBBS, MD',
      title: 'Consultant Eye Surgeon',
    },
    {
      name: 'Dr. Wasantha Gamage MBBS, MD',
      title: 'Consultant Eye Surgeon, Visiting Lecturer',
    },
    {
      name: 'Dr. Asela Abeydeera MBBS, DO',
      title: 'Community Ophthalmologist, Visiting Lecturer',
    },
    {
      name: 'Dr. Nalin Goonesinghe MBBS, DO',
      title: 'Community Ophthalmologist, Visiting Lecturer',
    },
    {
      name: 'Dr. Mapa Prabhath Piyasena MBBS, DO',
      title: 'Public Health Ophthalmologist, Research Specialist',
    },
    {
      name: 'Dr. C Nupearachchi PhD Physics',
      title: (
        <>
          Senior Lecturer,<br />
          University of Sri Jayewardenepura
        </>
      ),
    },
    {
      name: 'Dr. Amila Jayasekara MBBS',
      title: 'General Anatomy & Physiology, Visiting Lecturer',
    },
    {
     name: 'Dr. M Nazer MBBS',
     title: 'General Anatomy & Physiology',
    },

    {
      name: 'Ms. Siranthie Salgado M Ed',
      title: 'Lecturer, English, Open University of Sri Lanka',
    },

    {
      name: 'Vajira Perera PGD OHS',
      title: 'Lecturer, Occupational Health and Safety',
    },
    {
      name: 'Sandaruwan Alwis BSc (Hons)',
      title: 'Lecturer, Physics, University Of Ruhuna',
    },

    {
      name: 'Himidira Bopearachchi BSc IT, UOC ',
      title: 'Software Engineer, Lecturer, Information Technology',
    },

    {
      name: 'Thejan Balawickrama BSc (Hons), CMU ',
      title: 'Software Engineer, Lecturer, Information Technology',
    },

    {
      name: 'K Suranga Kumara PGD',
      title: 'Lecturer, Marketing / Management',
    },
    {
      name: 'E.Dhanawardana Dip. Pharma',
      title: 'Lecturer, Pharmacy - Ophthalmic Nurse - GHR',
    },
    {
      name: 'Thilina Jayasinghe BSc. (Hon) UOR',
      title: 'Lecturer, Biochemistry / Microbiology',
    },

    {
      name: 'Orthop. J U Seekubadu HDOT, BSc, MPhil',
      title: 'Snr Orthoptist, Visiting Lecturer',
    },
 
    {
      name: 'Pooja Ranasinghe MSc Neuroscience',
      title: 'Lecturer, Sri Jayewardenepura University',
    },
    {
      name: 'Junu Shrestha BOptom. MSc',
      title: 'Policy and Advocacy Manager, IAPB',
    },

    {
      name: 'Dr. Prakash Paudel B.Optom, PhD',
      title: (
        <>
          Adjunct senior lecturer,<br />
          University of New South Wales
        </>
      ),
    },
    {
      name: 'Yeshwantha Saoji',
      title: 'M Optom, F Optom, FIACLE',
    },
    {
      name: 'Naveen Samarasinghe M Optom',
  
      title: (
        <>
          Snr Optometrist, Lecturer,<br />
          Pediatric & Geriatric Optometry,<br />
          Sri Jayewardenepura University
        </>
      ),
    },
    {
      name: 'Sudharma Liyanage',
  
      title: (
        <>
          Snr.Optometrist/ Low Vision Practitioner,<br />
          National Eye Hospital, Colombo
        </>
      ),
    },
    {
      name: 'Naresh Pradhan HDOT, IACLE, F Optom',
      title: 'Senior Optometrist, vision Scientist',
    },
    {
      name: 'M A Dhammika Deshapriya HDOT',
      title: 'Senior Optometrist',
    },
    {
      name: 'Lilendra Perera B.Optom',
      title: 'Optometrist',
    },
    {
      name: 'N Arul Kumar Dip. Opt.',
      title: 'Snr Hospital Optometrist',
    },
    {
      name: 'K L M Rodrigo Dip. Opt.',
      title: 'Hospital Optometrist',
    },





  ];
  

  return (
    <div className="our-faculty">
      <h2>Our Faculty</h2>
      <div className="faculty-grid">
        {facultyData.map((facultyMember, index) => (
          <div key={index} className="faculty-card">
            <h3 className="faculty-info">{facultyMember.name}</h3>
            <p className="faculty-description">
              {facultyMember.title}
            </p>
            <div className="faculty-socials">
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OurFaculty;
